import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';

export const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#FFFFFF',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #0367bf',
  },
}))(Tooltip);
